import { useState } from 'react';
import styled from 'styled-components';
import { Collapse, Space } from 'antd';
import { DownOutlined, FileTextOutlined } from '@ant-design/icons';
import SuitCaseIcon from 'components/icons/SuitCaseIcon';
import { StyledIconWrapper } from 'components/new-ui/base/modal/styles';
import { ManifestDeclarationsResponse } from 'store/manifests/types';
import DeclarationStatusTag from 'components/ui/composed/declarations/declaration-status/DeclarationStatusTag';

const StyledCollapse = styled(Collapse)`
    .ant-collapse-content-box {
        padding: 0 !important;
    }
    .ant-collapse-header {
        padding: 0 !important;
    }
`;

const { Panel } = Collapse;

const ListItem = ({ jobId, jobReferenceId, declarations }: ManifestDeclarationsResponse) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <li>
            <StyledCollapse
                bordered={false}
                ghost
                expandIcon={() => null}
                style={{ padding: 0 }}
                onChange={(keys) => setIsOpen((keys as string[]).length > 0)}
            >
                <Panel
                    key={jobId}
                    header={
                        <div style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden' }}>
                            <Space size={6}>
                                <StyledIconWrapper style={{ width: 24, height: 24, fontSize: 14, borderRadius: 6 }}>
                                    <SuitCaseIcon />
                                </StyledIconWrapper>
                                <span>{jobReferenceId}</span>
                            </Space>
                            <Space size={8}>
                                <span style={{ color: 'var(--gray-7)', userSelect: 'none' }}>
                                    ({declarations.length} Declaration
                                    {declarations.length === 1 ? '' : 's'})
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <DownOutlined
                                        style={{
                                            transform: isOpen ? 'rotate(180deg)' : undefined,
                                            transition: 'transform 0.36s',
                                            color: 'var(--brand-6)',
                                        }}
                                    />
                                </span>
                            </Space>
                        </div>
                    }
                >
                    <ul style={{ listStyle: 'none', paddingLeft: 32, paddingBlock: 8 }}>
                        <Space style={{ width: '100%' }} direction="vertical" size={2}>
                            {declarations.map((dec) => (
                                <li
                                    key={dec.declarationId}
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <Space>
                                        <FileTextOutlined style={{ color: 'var(--brand-6)' }} />
                                        <span style={{ fontWeight: 600 }}>{dec.mrn ?? 'MRN not available'}</span>
                                    </Space>
                                    <DeclarationStatusTag status={dec.status} small />
                                </li>
                            ))}
                        </Space>
                    </ul>
                </Panel>
            </StyledCollapse>
        </li>
    );
};

export default ListItem;
